import React, { useEffect, useState } from "react";
import popupMessage from "../../../services/popupMessage";
import { instanceToken } from "../../../utils/constant";
import { useNavigate, Link } from "react-router-dom";

import {
  Breadcrumbs,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  TablePagination,
  Avatar,
} from "@mui/material";

export default function PopupMessages() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchMessages = async (limit, offset) => {
    try {
      const res = await popupMessage.findAll(
        instanceToken.token,
        limit,
        offset
      );
      const result = await res.data;
      setMessages(result?.popup_messages);
      setCount(result?.count);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  if (!messages) {
    return <em>Loading</em>;
  }

  return (
    <>
      <div role="presentation" style={{ marginBlockEnd: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <span>Popup Messages</span>
        </Breadcrumbs>
      </div>

      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          sx={{ my: 3 }}
          onClick={() => navigate("/popup-message/create")}
        >
          Create
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple-table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {/* <TableCell>Image</TableCell> */}
              <TableCell>Title</TableCell>
              <TableCell>Image</TableCell>

              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {messages.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>

                <TableCell>
                  {row.title !== "undefined" ? row?.title : "#"}
                </TableCell>
                <TableCell>
                  <Avatar
                    alt="partner image"
                    src={`${row.image_url}`}
                    width="56px"
                    height="56px"
                  />
                </TableCell>
                <TableCell>
                  <Button
                    size="small"
                    component={Link}
                    color="secondary"
                    to={`/popup-messages/${row.id}`}
                  >
                    Detail
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
}
